import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import SinAcceso from "../components/SinAcceso";
import { useAccesoVigente } from "../context/AccessControl/useAccesoVigente";

const Route = ({
	component: Component,
	isPrivate = false,
	requiredPermission = null,
	...rest
}) => {
	const { isAuth, loading } = useContext(AuthContext);
	const acceso = useAccesoVigente();

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		// Permitir acceso a rutas de autenticación incluso si está autenticado
		const authRoutes = ['/login', '/signup', '/privacy', '/terms'];
		if (authRoutes.includes(rest.path)) {
			return (
				<>
					{loading && <BackdropLoading />}
					<RouterRoute {...rest} component={Component} />
				</>
			);
		}
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />
			</>
		);
	}

	/**
	 * La guarda de permiso, el último paso antes de pintar.
	 *
	 * WHY solo decide con el snapshot cargado: mientras `/me/permissions` viaja,
	 * negar el paso expulsaría de su propia página a quien sí tiene el permiso.
	 * Y si esa petición falla del todo, se deja pasar a propósito — quien
	 * protege de verdad es el backend, que exige el mismo permiso en cada
	 * endpoint. Esta guarda evita la pantalla vacía y el enlace engañoso; no es
	 * la cerradura.
	 */
	if (isPrivate && requiredPermission && acceso.loaded && !acceso.can(requiredPermission)) {
		return (
			<RouterRoute
				{...rest}
				render={() => <SinAcceso permiso={requiredPermission} />}
			/>
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
